// Display metadata for the recruitment pipeline stages. The stage itself is
// derived server-side (helpers/applications/applicationStage.js) from what
// has actually happened on the application — references received, interviews
// booked/completed, offers extended — so these labels always match reality.

const STAGE_META = {
  Draft: {
    color: 'default',
    description: 'The applicant is still completing their application.',
  },
  Submitted: {
    color: 'info',
    description: 'Submitted and awaiting review.',
  },
  'Awaiting References': {
    color: 'warning',
    description: 'Reference requests sent — waiting on referee responses.',
  },
  'References Received': {
    color: 'info',
    description: 'Both references are in and ready to review.',
  },
  'Interview Scheduled': {
    color: 'secondary',
    description: 'An interview is booked and awaiting an outcome.',
  },
  'Interview Completed': {
    color: 'info',
    description: 'Interview held — record an outcome or extend an offer.',
  },
  'Offer Extended': {
    color: 'warning',
    description: 'Offer sent to the applicant — awaiting their response.',
  },
  'Offer Accepted': {
    color: 'success',
    description: 'The applicant accepted the offer — ready to approve.',
  },
  'Offer Declined': {
    color: 'error',
    description: 'The applicant declined the offer.',
  },
  Approved: {
    color: 'success',
    description: 'Approved — an employee record has been created.',
  },
  Rejected: {
    color: 'error',
    description: 'The application was rejected.',
  },
}

export const getStageMeta = (stage) =>
  STAGE_META[stage] ?? { color: 'default', description: '' }

export const INTERVIEW_OUTCOMES = [
  'Pending',
  'Passed',
  'Failed',
  'No Show',
  'Cancelled',
]

export const OUTCOME_COLORS = {
  Pending: 'info',
  Passed: 'success',
  Failed: 'error',
  'No Show': 'warning',
  Cancelled: 'default',
}

export default STAGE_META
